import { Status } from "./Status";

export class DataPayload
{
    status: Status = Status.uninitialized;
    data: any;
}
